jQuery.feature_import("js-resizable",
  () => require("./resizable-bs-modal.js"),
  mod => mod.feature_js_resizable
);